module.exports = __webpack_public_path__ + "fonts/DroidKufi-Regular.fd8d5b98.eot";